// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__WCDon","rootCenter":"LoadMoreObserver_rootCenter__1-nGs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2SmL0"};